import { SITE_EMAIL } from "../../shared/seo/site";

export function Contact() {
  return (
    <main className="prose-page" id="main-content">
      <p className="eyebrow">Get in touch</p>
      <h1>Contact</h1>
      <p className="lede">One person reads this inbox, so a reply may take a few days — but every message is read.</p>
      <section>
        <span className="section-number">01</span>
        <div>
          <h2>Email</h2>
          <p>Write to <a href={`mailto:${SITE_EMAIL}`}>{SITE_EMAIL}</a>. There is no contact form, no ticket number, and no autoresponder.</p>
        </div>
      </section>
      <section>
        <span className="section-number">02</span>
        <div>
          <h2>Reporting a broken puzzle</h2>
          <p>If a grid seems to have no solution or more than one, that is a bug worth hearing about. Include the date or the puzzle's size and the clues you were stuck on. Every puzzle is checked by a solver before it ships, so a real counter-example is genuinely useful.</p>
        </div>
      </section>
      <section>
        <span className="section-number">03</span>
        <div>
          <h2>Privacy requests</h2>
          <p>The site holds no account and stores nothing about you on its servers, so there is usually no personal data to export or delete — clearing your browser's site data removes everything the site kept. If you still have a question about what is collected, this address is the right place to ask.</p>
        </div>
      </section>
      <section>
        <span className="section-number">04</span>
        <div>
          <h2>Everything else</h2>
          <p>Suggestions for pictures, notes on the mobile experience, accessibility problems, and questions about reusing the printable sheets are all welcome.</p>
        </div>
      </section>
    </main>
  );
}
